import React from 'react';
import cn from '@/utils/cn';
import Icon from '@/components/ui/Icon';

type CommentButtonProps = {
  newCommentCount: number;
  commentDrawer: boolean;
  setCommentDrawer: (state: boolean) => void;
};

const CommentButton = ({ newCommentCount, commentDrawer, setCommentDrawer } : CommentButtonProps) => (
  <button
    className={cn('tw-relative tw-flex tw-justify-center tw-items-center tw-w-[2rem] tw-h-[1.5rem] tw-rounded-sm',
      'tw-bg-light-grey tw-border tw-border-solid tw-border-grey')}
    type="button"
    onClick={() => setCommentDrawer(!commentDrawer)}
  >
    <Icon fill="#777770" height="16" icon="TeacherComment" width="16" />
    {newCommentCount > 0 && (
      <span className="tw-absolute tw-text-xs tw-bg-red tw-rounded-full tw-w-4 tw-h-4 -tw-top-2 -tw-right-2 tw-flex
      tw-justify-center tw-items-center tw-text-white"
      >
        {newCommentCount}
      </span>
    )}
  </button>
);

export default CommentButton;
